import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const PageTitle = ({ title, ellipsis, className }) => {
  const componentClassName = classNames(className, {
    'header-in-page_title': true,
    'overflow-ellipis': ellipsis,
    'is-loading': !title
  })

  if (title) {
    return (
      <h1 className={componentClassName}>{title}</h1>
    )
  }

  return null
}

PageTitle.defaultProps = {
  title: undefined,
  ellipsis: true,
  className: undefined
}

PageTitle.propTypes = {
  title: PropTypes.string,
  ellipsis: PropTypes.bool,
  className: PropTypes.string
}
